import * as React from "react";

import { Spin } from "antd";

const ScreenLoading = () => {
	return (
		<div
			style={{
				margin: "auto",
				width: "100%",
				position: "fixed",
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				zIndex: 999,
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				backgroundColor: "rgba(0,0,0, 0.3)",
			}}
		>
			<Spin size={"large"} />
		</div>
	);
};

export default ScreenLoading;
